export default {
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  BACKSPACE: 8,
  ENTER: 13,
  ESCAPE: 27,
  TAB: 9,
} as const
